import React, { useEffect, useState } from 'react'
import TextOrNumberField from '../../DataEntryPage/Fields/TextOrNumberField'
import DateAndDateTime from '../../DataEntryPage/Fields/DateAndDateTime'
import { Autocomplete, TextField } from '@mui/material'
import FilePreviewField from '../../DataEntryPage/Fields/FilePreviewField'
import FileUploadField from '../../DataEntryPage/Fields/FileUploadField'
import BigTextField from '../../DataEntryPage/Fields/BigTextField'
import CurrencyField from '../../DataEntryPage/Fields/CurrencyField'
import { FIELD_TYPES } from '../../../utility/constants'
import moment from 'moment'
import { fileServices } from '../../../services/fileServices'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { listDataService } from '../../../services/listDataService'
import { textFieldStyle } from './CreateProcessTemplateDialog'

const DecoupledDefaultValueField = ({
  dataStructure,
  listId,
  value,
  onValueChange,
  isListDataId = false,
}) => {
  const { user } = useAuthContext()
  const [listDataItems, setListDataItems] = useState([])

  const handleDefaultFileUpload = async (e) => {
    const file = e.target.files[0]
    const result = (await fileServices.uploadFile(user, file)).data
    const key = result?.filePath?.split('/')[1] || ''
    onValueChange(key)
  }

  useEffect(() => {
    ;(async () => {
      if ([FIELD_TYPES.LIST, FIELD_TYPES.LIST_MULTI].includes(dataStructure)) {
        const listItems = await listDataService.getData(user, listId)
        setListDataItems(listItems?.data || [])
      }
    })()
  }, [dataStructure, listId, user])

  if (dataStructure === FIELD_TYPES.NUMBER || dataStructure === FIELD_TYPES.TEXT) {
    return (
      <TextOrNumberField
        label="Default Value"
        value={value}
        sx={textFieldStyle}
        onChange={(e) => onValueChange(e.target.value)}
      />
    )
  } else if (dataStructure === FIELD_TYPES.DATETIME || dataStructure === FIELD_TYPES.DATE) {
    return (
      <DateAndDateTime
        sx={textFieldStyle}
        value={moment(value)}
        label="Default Value"
        onChange={(e) => onValueChange(e?.format('YYYY-MM-DD HH:mm:ss'))}
      />
    )
  } else if (dataStructure === FIELD_TYPES.LIST) {
    return (
      <Autocomplete
        sx={textFieldStyle}
        id="default-value-list-field"
        size="small"
        options={listDataItems}
        value={
          listDataItems.find((it) => (isListDataId ? value === it.id : value === it?.value)) || null
        }
        getOptionLabel={(option) => option.value}
        label="Default Value"
        onChange={(_, v) => onValueChange(isListDataId ? v?.id : v?.value)}
        renderInput={(params) => {
          return <TextField {...params} label="Default Value" />
        }}
      />
    )
  } else if (dataStructure === FIELD_TYPES.LIST_MULTI) {
    return (
      <Autocomplete
        multiple
        sx={textFieldStyle}
        id="default-value-list-multi-field"
        size="small"
        options={listDataItems}
        value={listDataItems.filter((it) => value?.split(',').includes(it.id + '')) || []}
        getOptionLabel={(option) => option.value}
        label="Default Value"
        onChange={(_, v) => onValueChange(v?.map((it) => it.id).join(','))}
        renderInput={(params) => {
          return <TextField {...params} label="Default Value" />
        }}
      />
    )
  } else if (dataStructure === FIELD_TYPES.FILE) {
    return value ? (
      <FilePreviewField
        value={value}
        sx={textFieldStyle}
        download={() => fileServices.downloadFile(user, value)}
        clear={() => onValueChange('')}
      />
    ) : (
      <FileUploadField placeholder="Upload Default File" onChange={handleDefaultFileUpload} />
    )
  } else if (dataStructure === FIELD_TYPES.BIGTEXT) {
    return (
      <BigTextField
        sx={textFieldStyle}
        placeholder="Default Value"
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
      />
    )
  } else if (dataStructure === FIELD_TYPES.CURRENCY) {
    return (
      <CurrencyField
        sx={textFieldStyle}
        label="Default Value"
        value={value}
        onChange={(e) => onValueChange(e.floatValue)}
      />
    )
  } else {
    return (
      <TextField
        sx={textFieldStyle}
        type="text"
        value={value}
        fullWidth
        size="small"
        variant="outlined"
        color="primary"
        onChange={(e) => onValueChange(e.target.value)}
        label={`Default Value`}
      />
    )
  }
}

export default DecoupledDefaultValueField
